<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->

<template>

  <div id="bedrock">

    <template v-if="systemBoot.ready">

      <RouterView v-if="!authState.isAuthenticated" />
      <Bedrock v-else />

      <BedrockNotification />
      <BedrockModal />
      <BedrockLogSidebar />

    </template>

    <div v-else class="sdev-boot">
      {{ systemBoot.message || "Booting Bedrock..." }}
    </div>

  </div>

</template>

<script setup>

import { onMounted } from "vue"

import { authState } from "@/domain/auth/auth.state"
import { systemBoot } from "@/domain/system/system.boot"

import { isTokenValid } from "@/domain/auth/auth.service"
import { initializeNavigation } from "@/domain/navigation"

import Bedrock from "@/reflection/Core/Bedrock.vue"
import BedrockNotification from "@/reflection/Core/BedrockNotification.vue"
import BedrockModal from "@/reflection/Core/BedrockModal.vue"
import BedrockLogSidebar from "@/reflection/Core/BedrockLogSidebar.vue"

onMounted(async () => {

  document.body.classList.remove("transitioning")

  if (isTokenValid()) {

    systemBoot.setPhase("initializing", "Initializing Bedrock")
    authState.isAuthenticated = true
    await initializeNavigation()

    systemBoot.setPhase("ready")
    systemBoot.ready = true

  } else {

    systemBoot.setPhase("idle")
    authState.isAuthenticated = false
    systemBoot.ready = true

  }

})

</script>